import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
export const Swimmlane = ({ children, className, }) => {
    return (_jsx("div", { className: cn('bg-swimmlane-background text-swimmlane-foreground mx-auto mt-6 max-w-md rounded-md px-2 py-1 text-center text-sm font-semibold leading-4', className), children: children }));
};
